import { ClickAwayListener, MenuList } from '@mui/material'
import ListItemIcon from '@mui/material/ListItemIcon/ListItemIcon'
import ListItemText from '@mui/material/ListItemText/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import React, { useEffect, useRef, useState } from 'react'
import {
  MasterLabelDoc,
  MasterLabelLabel,
  UserSettingsDoc
} from 'types/api/changes'
import { t } from 'i18next'
import { Model } from 'types/model'
import { useAppUIType } from 'components/providers/AppUITypeProvider'
import { LabelIconMenu } from 'assets/icons'

interface ContextMenuProps {
  label: MasterLabelLabel
  userSettings?: Model<UserSettingsDoc> | UserSettingsDoc
  masterLabel?: Model<MasterLabelDoc>
  x: number // X-coordinate of the click event
  y: number // Y-coordinate of the click event
  onClose: () => void // Callback to close the context menu
}

const menuItemStyle: React.CSSProperties = { padding: '8px 4px' }

const menuItemTextStyle: React.CSSProperties = {
  fontSize: '14px',
  fontFamily: 'NotoSans',
  fontWeight: 400
}

const iconSX: React.CSSProperties = {
  minWidth: '26px !important'
}

const LabelItemContextMenu: React.FC<ContextMenuProps> = ({
  label,
  userSettings,
  masterLabel,
  x,
  y,
  onClose
}) => {
  const menuRef = useRef<HTMLUListElement>(null)
  const [adjustedPosition, setAdjustedPosition] = useState({ top: y, left: x })
  const tfmUIContext = useAppUIType()

  useEffect(() => {
    if (!menuRef.current) return

    const menuRect = menuRef.current.getBoundingClientRect()
    const viewportHeight = window.innerHeight
    const bottomSpace = viewportHeight - y

    // If menu extends beyond viewport bottom, position it above the click point
    if (bottomSpace < menuRect.height + 10) {
      setAdjustedPosition({
        top: Math.max(10, y - menuRect.height),
        left: x
      })
    } else {
      setAdjustedPosition({ top: y, left: x })
    }
  }, [y, x])

  const showLabelDetails = () => {
    if (label.ID) {
      tfmUIContext.setLabelInfo(label.ID)
    }

    onClose()
  }

  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={onClose}
    >
      <ul
        ref={menuRef}
        style={{
          position: 'absolute',
          width: 'fit-content',
          top: adjustedPosition.top,
          left: adjustedPosition.left,
          listStyleType: 'none',
          zIndex: 99999,
          fontSize: '14px',
          padding: '0px 8px',
          borderRadius: '20px',
          backgroundColor: 'white',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
        }}
      >
        <MenuList sx={{ fontSize: '14px' }}>
          <MenuItem onClick={showLabelDetails} sx={menuItemStyle}>
            <ListItemIcon sx={iconSX}>
              <LabelIconMenu />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ sx: menuItemTextStyle }}>
              {t('labelDetails')}
            </ListItemText>
          </MenuItem>
        </MenuList>
      </ul>
    </ClickAwayListener>
  )
}

export default LabelItemContextMenu
